<app-generic-overlay
    [overlayOrigin]="overlayOrigin"
    [headerTemplate]="headerTemplate"
    [mainActionable]="mainActionable"
    [actionButtonsRef]="actionButtonsRef"
    (isOverlayOpenChange)="onOverlayChange($event)"
>
    <ng-template #headerTemplate let-close="close">
        <div class="header">
            <button class="resetStyles close-btn" aria-label="Close panel" (click)="close()">
                <div [innerHTML]="closeIcon" class="icon"></div>
            </button>
        </div>
    </ng-template>

    <article class="container">
        <section class="filtersContainer">
            <form [formGroup]="additionalFiltersForm" class="formSection">
                @if (filtersVisibility().dueDate) {
                    <div class="filterSection">
                        <app-date-range-form-editor
                            labelText="Due Date"
                            [readonly]="readonlyFields()?.dueDate ?? false"
                            rangeDirection="forward"
                            placeholderText="Add Due Date"
                            formControlName="dueDateRange"
                        ></app-date-range-form-editor>
                    </div>
                }

                @if (filtersVisibility().expectedBookingDate) {
                    <div class="filterSection">
                        <app-date-range-form-editor
                            labelText="Exp. Booking Date"
                            [readonly]="false"
                            rangeDirection="forward"
                            placeholderText="Add Exp. Booking Date"
                            formControlName="expectedDateRange"
                        ></app-date-range-form-editor>
                    </div>
                }

                @if (filtersVisibility().country) {
                    <div class="filterSection">
                        <app-country-form-editor [readonly]="false" labelText="Country" formControlName="country">
                        </app-country-form-editor>
                    </div>
                }

                @if (filtersVisibility().state) {
                    <div class="filterSection">
                        <app-state-form-editor [readonly]="false" labelText="State" formControlName="state">
                        </app-state-form-editor>
                    </div>
                }

                @if (filtersVisibility().city) {
                    <div class="filterSection">
                        <app-city-form-editor [readonly]="false" labelText="City" formControlName="city">
                        </app-city-form-editor>
                    </div>
                }

                @if (filtersVisibility().account) {
                    <div class="filterSection">
                        <app-account-form-editor [readonly]="false" formControlName="accounts">
                        </app-account-form-editor>
                    </div>
                }
                @if (filtersVisibility().company) {
                    <div class="filterSection">
                        <app-companies-form-editor
                            [readonly]="false"
                            [placeholderText]="
                                !!config().extraConfigs?.company?.multiple ? 'Select Companies' : 'Select Company'
                            "
                            [multiple]="!!config().extraConfigs?.company?.multiple"
                            [labelText]="!!config().extraConfigs?.company?.multiple ? 'Companies' : 'Company'"
                            formControlName="companies"
                        >
                        </app-companies-form-editor>
                    </div>
                }

                @if (filtersVisibility().companyRole) {
                    <div class="filterSection">
                        <app-company-roles-form-editor [readonly]="false" formControlName="companyRoles">
                        </app-company-roles-form-editor>
                    </div>
                }

                @if (filtersVisibility().potentialValue) {
                    <div class="filterSection">
                        <app-dropdown-ranges-form-editor
                            labelText="Potential Value ($)"
                            [readonly]="false"
                            placeholderText="Set Potential Value Range"
                            iconType="dollar"
                            [minValue]="0"
                            formControlName="potentialValueRange"
                        ></app-dropdown-ranges-form-editor>
                    </div>
                }

                @if (filtersVisibility().proposedGrossMargin) {
                    <div class="filterSection">
                        <app-dropdown-ranges-form-editor
                            labelText="Potential GM (%)"
                            [readonly]="false"
                            placeholderText="Set Potential GM Range"
                            iconType="percentage"
                            [minValue]="0"
                            [maxValue]="100"
                            formControlName="potentialGrossMarginRange"
                        ></app-dropdown-ranges-form-editor>
                    </div>
                }

                @if (filtersVisibility().probability) {
                    <div class="filterSection">
                        <app-dropdown-ranges-form-editor
                            labelText="Probability (%)"
                            [readonly]="false"
                            placeholderText="Set Probability Range"
                            iconType="percentage"
                            [minValue]="0"
                            [maxValue]="100"
                            formControlName="probabilityRange"
                        ></app-dropdown-ranges-form-editor>
                    </div>
                }

                @if (filtersVisibility().department) {
                    <div class="filterSection">
                        <app-department-form-editor
                            [readonly]="false"
                            formControlName="departments"
                        ></app-department-form-editor>
                    </div>
                }

                @if (filtersVisibility().salesperson) {
                    <div class="filterSection">
                        <app-salespersons-form-editor
                            [readonly]="false"
                            formControlName="salespersons"
                        ></app-salespersons-form-editor>
                    </div>
                }

                @if (filtersVisibility().status) {
                    <div class="filterSection">
                        <app-statuses-form-editor
                            [readonly]="false"
                            formControlName="statuses"
                        ></app-statuses-form-editor>
                    </div>
                }

                @if (filtersVisibility().market) {
                    <div class="filterSection">
                        <app-market-form-editor [readonly]="false" formControlName="market"></app-market-form-editor>
                    </div>
                }

                @if (filtersVisibility().companyType) {
                    <div class="filterSection">
                        <app-company-type-form-editor
                            [readonly]="false"
                            formControlName="companyType"
                        ></app-company-type-form-editor>
                    </div>
                }

                @if (filtersVisibility().companyMainContact) {
                    <div class="filterSection">
                        <app-company-main-contact-form-editor
                            [readonly]="false"
                            labelText="Main Contact"
                            [multiple]="false"
                            formControlName="contact"
                        ></app-company-main-contact-form-editor>
                    </div>
                }

                @if (filtersVisibility().accountType) {
                    <div class="filterSection">
                        <app-account-type-form-editor
                            [readonly]="false"
                            formControlName="accountType"
                        ></app-account-type-form-editor>
                    </div>
                }

                @if (filtersVisibility().includeArchived) {
                    <div class="filterSection">
                        <app-include-archived-form-editor
                            formControlName="includeArchived"
                        ></app-include-archived-form-editor>
                    </div>
                }
            </form>
        </section>
    </article>

    <ng-template #actionButtonsRef let-close="close">
        <div class="action-buttons">
            <button
                (click)="onClearFilters(); close()"
                class="tertiary-btn clear-btn"
                [disabled]="!hasSelectedFilters()"
            >
                Clear All
            </button>
            <button (click)="onSubmit(); close()" class="tertiary-btn apply-btn">Apply</button>
        </div>
    </ng-template>
</app-generic-overlay>

<div cdkOverlayOrigin #overlayOrigin="cdkOverlayOrigin">
    <ng-template #mainActionable let-openClose="openClose">
        <button (click)="openClose()" [ngClass]="{ opened: opened() }" class="additional-btn tertiary-btn">
            <span
                class="icon"
                [innerHTML]="!opened() && hasAppliedFilters() ? appliedAdditionalFiltersIcon : additionalFiltersIcon"
            ></span>
            <span>Additional filters</span>
        </button>
    </ng-template>
</div>
